import React, { useContext } from 'react';
import { st, classes } from '../../Widget.st.css';
import { Structure } from '../../../../../enums';
import { useSettings } from '@wix/tpa-settings/react';
import { ISettingsContextValue } from '@wix/tpa-settings';
import settingsParams from '../../../settingsParams';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';

import ListTwoColumns from './ListTwoColumns/ListTwoColumns';
import { AccordionCSS } from '../Interfaces';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import ListOneColumn from './ListOneColumn/ListOneColumn';
import { DATA_HOOKS } from '../../../../../constants/dataHooksElements';
import { useLayoutType } from '../../../../../hooks/useLayoutType';
import { AppContext } from '../../SettingsProvider/SettingsProvider';

const ListWrapper = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const settings: ISettingsContextValue = useSettings();
  const { isMobile } = useEnvironment();

  const structureColumn: Structure = settings.get(settingsParams.structure);
  const twoColumnStructure: boolean =
    structureColumn === Structure.TWO_COLUMNS && !isMobile;
  const { isEditor3 } = useContext(AppContext);
  const {
    spacing: { gap, betweencols },
  } = useLayoutType(isEditor3);
  const customStyle = {
    '--item-gap': `${gap}px`,
    '--column-gap': `${betweencols}px`,
  } as AccordionCSS;
  return (
    <div
      style={customStyle}
      className={st(
        classes.Body,
        { isTwoColumn: twoColumnStructure },
        classes.listLayout,
      )}
      data-hook={DATA_HOOKS.WIDGET_LIST_WRAPPER}
      role="tab"
    >
      {twoColumnStructure ? (
        <ListTwoColumns filteredQuestions={filteredQuestions} />
      ) : (
        <ListOneColumn filteredQuestions={filteredQuestions} />
      )}
    </div>
  );
};

export default ListWrapper;
